<template>
  <v-row justify="center">
    <v-dialog
      v-model="createStudentDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Create New Membership
        </v-btn>
      </template>
      <v-card>
        <v-app-bar
          dark
          color="primary"
          class="video-ui"
        >
          <v-btn
            icon
            dark
            @click="createStudentDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Create New Membership</v-toolbar-title>
        </v-app-bar>
        <div class="camera-container">
          <video
            ref="video"
            autoplay
            class="camera"
            muted
            playsinline
          ></video>
          <div class="mask">
            <div
              ref="boundary"
              class="boundary"
              :style="{ width: boundaryWidth + 'px', height: boundaryHeight + 'px' }"
            ></div>
          </div>
          <!-- <v-progress-circular
            v-if="isLoading"
            :indeterminate="isLoading"
            color="white"
          ></v-progress-circular> -->
          <v-btn
            class="capture"
            color="primary"
            @click="capture"
          >
            Capture
          </v-btn>
          <form
            ref="fileForm"
            method="post"
          >
            <input
              id="hkid"
              ref="hkid"
              type="file"
              name="hkid"
            />
          </form>
        </div>
      </v-card>
      <v-overlay
        :z-index="999"
        :value="isLoading"
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>
  </v-row>
</template>

<script>
import { ref } from 'vue'
import axios from 'axios'

// import InputContainer from '@/components/CRUD/InputContainer'

export default {
  name: 'CreateStudent',
  components: {
    // InputContainer,
  },
  props: {
    studentFormConfig: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      isLoading: false,
      classList: 'image-container mr-5 ml-5 ',
      createStudentDialog: false,
      boundaryWidth: 0,
      boundaryHeight: 0,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  watch: {
    isMobile(isMobileValue) {
      console.log('isMobileValue', isMobileValue)
      const baseClass = 'image-container mr-5 ml-5 '
      if (isMobileValue) {
        this.classList = `${baseClass}mt-5`
      } else {
        this.classList = baseClass
      }
    },
    createStudentDialog(visible) {
      console.log('trigger createStudentDialog')
      if (visible) {
        // Here you would put something to happen when dialog opens up
        console.log('Dialog was opened!')
        this.$nextTick(async () => {
          console.log('this.$refs', this.$refs)
          try {
            /* open the device you want */
            const constraints = {
              video: {
                facingMode: { exact: 'environment' },
                width: this.$vuetify.breakpoint.height,
                height: this.$vuetify.breakpoint.width,
              },
              audio: false,
            }
            console.log('constraints', constraints)
            const stream = await navigator.mediaDevices.getUserMedia(constraints)
            this.$refs.video.srcObject = stream
          } catch (error) {
            console.log("Device doesn't have enviroment camera")
            alert("Device doesn't have enviroment camera")
            console.log('demo video')
          }

          console.log('this.$refs.boundary', this.$refs.boundary)
          this.calcBoundary()
        })
      } else {
        console.log('Dialog was closed!')

        // window.alert('close stream')
        this.$refs.video.srcObject.getTracks().forEach(track => track.stop())
      }
    },
  },
  mounted() {
  },
  methods: {
    calcBoundary() {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight - 56
      if (this.$refs.boundary) {
        this.boundaryHeight = windowHeight * 0.75

        // height 4, width 3
        this.boundaryWidth = (this.boundaryHeight / 16) * 9

        console.log('this.boundaryHeight this.boundaryWidth', this.boundaryHeight, this.boundaryWidth)
      }
    },
    capture() {
      const canvas = document.createElement('canvas')
      const { video } = this.$refs
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      const imageDataUrl = canvas.toDataURL('image/png')
      console.log(imageDataUrl)

      // Split the data URL into the MIME type and the base64-encoded data
      const [mimeType, imageDataBase64] = imageDataUrl.split(',')

      // Decode the base64-encoded data
      const imageBinaryData = Buffer.from(imageDataBase64, 'base64')

      // Create a Uint8Array from the binary data
      const imageArray = new Uint8Array(imageBinaryData)

      // Create a Blob from the typed array
      const imageBlob = new Blob([imageArray], { type: mimeType })

      // Create a FormData object and append the Blob to it
      const formData = new FormData()
      formData.append('hkid', imageBlob)

      this.isLoading = true

      // const ocrUrl = 'http://localhost:5000/hkid_ocr'
      const ocrUrl = process.env.VUE_APP_OCR_URL
      axios.post(ocrUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          console.log(response)
          this.$store.dispatch('order/saveNewMember', response.data).then(newMember => {
            console.log('store newMember', newMember)
          })
          this.createStudentDialog = false
          this.$emit('scanned')
        })
        .catch(error => {
          console.log(error)
          window.alert('OCR Service is not available. Please contact the administrator. You could manually input student information.')
        }).finally(() => {
          this.isLoading = false
          this.$refs.video.srcObject.getTracks().forEach(track => track.stop())
        })
    },
  },
}
</script>
<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.camera {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}
.video-ui {
  z-index: 10;
}
.boundary {
  border: white;
  border-width: 5px;
  border-style: solid;
  z-index: 999;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent;
}
/* .mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
} */
.capture {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%);
  z-index: 999;
}
</style>
